import script from "./DevDemoComp.vue?vue&type=script&setup=true&lang=js"
export * from "./DevDemoComp.vue?vue&type=script&setup=true&lang=js"

import "./DevDemoComp.vue?vue&type=style&index=0&id=bf0eeda8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf0eeda8"]])

export default __exports__